import {
  Component,
  ElementRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { EmailBodyTags } from './email.tag';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-member-email-template',
  templateUrl: './member-email-template.component.html',
  styleUrl: './member-email-template.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class MemberEmailTemplateComponent {
  @ViewChild('EmailBody') emailFullBody!: ElementRef;
  public selMenu = 'send';
  public testEmailId: string = '';
  public selectTemplate: any = null;
  public productType1: any = null;
  public productType2: any = null;
  public productType3: any = null;
  public allRegionList: Array<any> = [];
  public allTemplateList: Array<any> = [];
  public allSelectedTemplateList: Array<any> = [];
  public form: FormGroup = new FormGroup({
    id: new FormControl(''),
    templateName: new FormControl('', [Validators.required]),
    subRegionId: new FormControl(null),
    subject: new FormControl('', [Validators.required]),
    body: new FormControl('', [Validators.required]),
    footer: new FormControl('', [Validators.required]),
  });
  public contentEditable: boolean = false;
  public previewEmailData: any = '';
  public commonModalRef: any = null;
  public userEmailIds = '';
  public emailSubject = '';
  public emailBody: SafeHtml;
  public enableAddProductSection: boolean = false;
  public footerSection: any = null;
  public selectedMemberRegion = null;
  public selectedMemberRegionId = '';
  public userEmailList: Array<any> = [];
  public templateSection: any = {
    logo: false,
    banner: false,
  }

  constructor(
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public modalService: NgbModal
  ) {
    this._getAllTemplate();
  }

  ngOnInit(): void {
    this.commonService.regionObserver.subscribe((resp: any) => {
      this.allRegionList = resp.map((i) => {
        return {
          keyName: i.name,
          sub: i.subRegions.map((i: any) => {
            return { ...i, keyName: i.name };
          }),
        };
      });
    });
  }

  public updatePreviewData() {
    this.previewEmailData = this.sanitizer.bypassSecurityTrustHtml(
      this.form.get('body').value + this.form.get('footer').value
    );
    return true;
  }

  public saveTemplate() {
    if (this.form.invalid) {
      this.toastr.error('Form is Invalid fill ALL ');
      return;
    }

    this.auth
      .addEmailTemplate({
        id: this.form.get('id').value,
        templateName: this.form.get('templateName').value.toUpperCase(),
        subject: this.form.get('subject').value,
        body: this.form.get('body').value,
        footer: this.form.get('footer').value,
        subRegionId: this.form.get('subRegionId').value,
      })
      .subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.reset();
        this._getAllTemplate();
      });
  }

  public _getAllTemplate() {
    this.auth.getAllEmailTemplate().subscribe((resp: ApiResponse) => {
      this.allTemplateList = resp.body;
      // this.allSelectedTemplateList = [this.allTemplateList[4]]; //remove
      // this.formTemplateForSending(0); //remove
      // this.productType = "community"; //remove
    });
  }

  public setTemplate(value) {
    let selected = this.allTemplateList.filter((i) => i.id == value)[0] || null;
    if (selected) {
      this.form.patchValue({
        id: selected?.id,
        templateName: selected?.templateName,
        subject: selected?.subject,
        body: selected?.body,
        footer: selected?.footer,
        subRegionId: selected?.subRegionId,
      });
      this.previewEmailData = this.sanitizer.bypassSecurityTrustHtml(
        this.form.get('body').value
      );
      this.selectedMemberRegion =
        this.commonService.getSubregionName(selected?.subRegionId) || null;
      this.updatePreviewData();
    } else {
      this.reset();
    }
  }

  public reset() {
    this.form.patchValue({
      id: '',
      templateName: '',
      subject: '',
      body: '',
      footer: '',
      subRegionId: '',
    });
    this.previewEmailData = '';
    this.selectTemplate = null;
    this.selectedMemberRegion = null;
    this.selectedMemberRegionId = '';
  }

  public remove() {
    if (this.form.get('id').value) {
      this.auth
        .deleteEmailTemplate(this.form.get('id').value)
        .subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this._getAllTemplate();
          this.reset();
        });
    } else {
      this.toastr.error('Select Template!');
    }
  }

  public sendTextMail(Modal) {
    this.commonModalRef = this.modalService.open(Modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public sendMail(Modal) {
    if (this.form.get('id').value && this.testEmailId) {
      this.auth
        .sendTestMail({
          id: this.form.get('id').value,
          emailId: this.testEmailId,
        })
        .subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.commonModalRef.close();
        });
    } else {
      this.toastr.error('Select Template/Email Id');
    }
  }
  editorEmailBody: string = '';
  productTypeSection: any = [];
  onTemplateChange(e: any) {
    console.log(e.target.value);
    this.productTypeSection.push(
      `${e.target.value}_${this.productTypeSection.length + 1}`
    );
    this.editorEmailBody += `<br/><div contenteditable="false" id="${e.target.value}_${this.productTypeSection.length}">[${e.target.value} ${this.productTypeSection.length} Section]</div><br />`;
    const textArea = document.getElementById('text-area') as HTMLElement;
    textArea.innerHTML = this.editorEmailBody;
  }
  removeSection(id) {
    this.productTypeSection = this.productTypeSection.filter(
      (item) => item !== id
    );
    const targetDiv = document.getElementById(id);

    if (targetDiv) {
      // Remove the target div from its parent
      const parentDiv = targetDiv.parentElement;
      if (parentDiv) {
        parentDiv.removeChild(targetDiv);
        const regex = new RegExp(`<div[^>]*id="${id}"[^>]*>.*?</div>`, 'gs');
        this.editorEmailBody = this.editorEmailBody.replace(regex, '');
      }
    } else {
      console.warn(`Element with id "${id}" not found.`);
    }
  }
  splitText(i, s) {
    return s.split('_')[i];
  }
  public sendHtmlInMail() {


    new Promise((resolve, reject) => {
      try {
        this.productTypeSection.forEach((e) => {
          const divElement = document.querySelector(`label[for="${e}"]`);
          if (divElement) {
            const divHTML = divElement.outerHTML;
            const regex = new RegExp(`<div.*?id="${e}".*?>.*?</div>`, 'g');
            this.editorEmailBody = this.editorEmailBody.replace(regex, divHTML);
          }
        });

        resolve('Loop completed');
      } catch (error) {
        reject(error);
      }
    })
      .then(() => {
        // this.auth
        //   .sendMail({
        //     emailId: 'ahmedmasry187@gmail.com',
        //     subject: this.emailSubject,
        //     body: ` <html>
        //     <head>
        //       <style>
        //         .body-mail {
        //           font-size: 16px;
        //           width: 100%;
        //           max-width: 1300px;
        //           margin: 15px auto;
        //           font-family: Geneva, "Segoe UI", Tahoma, Verdana, sans-serif;
        //           background-color: #f9f9f9;
        //           line-height: 1.6;
        //           width: 100%;
        //           border-radius: 16px;
        //           overflow: hidden;
        //         }
        //         .content-email {
        //           padding: 4px 16px;
        //         }

        //         .card-mail {
        //           width: 215px;
        //           display: inline-block;
        //           margin: 0 8px 16px;
        //           border: 1px solid #0000005b;
        //           background-color: #fff;
        //           padding: 8px;
        //           border-radius: 8px;
        //           height: 100%;
        //         }
        //         .card-mail .card-mail__image {
        //           width: 100%;
        //           border-radius: 8px;
        //           height: 250px;
        //           overflow: hidden;
        //         }
        //         .card-mail .card-mail__image img {
        //           width: 100%;
        //           border-radius: 8px;
        //           object-fit: cover;
        //           height: 100%;
        //         }

        //         .card-mail .card-mail__header {
        //           display: flex;
        //           margin: 16px 0 8px;
        //           align-items: flex-start;
        //           justify-content: space-between;
        //         }
        //         .card-mail .card-mail__header .card-mail__title {
        //           width: 80%;
        //         }
        //         .card-mail .card-mail__header .card-mail__title div {
        //           margin-right: 8px;
        //           font-size: 18px;
        //           line-height: 1.1;
        //           height: 39.6px;
        //           font-weight: 600;
        //           overflow: hidden;
        //         }
        //         .card-mail .card-mail__header .card-mail__logo {
        //           width: 20%;
        //           min-height: 50px;
        //           padding: 8px 0;
        //           border-radius: 8px;
        //           object-fit: cover;
        //           display: flex;
        //           background-color: #fff;
        //           border: 1px solid #0000005b;
        //         }
        //         .card-mail .card-mail__header .card-mail__logo img {
        //           width: 85%;
        //           height: fit-content;
        //           margin: auto;
        //         }

        //         .card-mail .card-mail__footer .price {
        //           color: #592880;
        //           font-size: 24px;
        //           font-weight: 600;
        //         }
        //         .card-mail .card-mail__footer .price span {
        //           font-size: 16px;
        //         }
        //         .card-mail .card-mail__footer .price small {
        //           font-size: 12px;
        //         }
        //         .card-mail .card-mail__footer .favorite {
        //           display: flex;
        //           margin-left: auto;
        //           align-items: center;
        //         }
        //         .card-mail .card-mail__footer .favorite span {
        //           margin-right: 4px;
        //           font-size: 16px;
        //         }
        //         .card-mail .card-mail__footer .favorite img {
        //           width: 16px;
        //         }

        //         .card-mail .card-mail__tags {
        //           color: #fff;
        //           font-size: 14px;
        //           display: flex;
        //           align-items: center;
        //           justify-content: space-between;
        //         }
        //         .card-mail .card-mail__tags .tag {
        //           padding: 0 4px;
        //           border-radius: 4px;
        //           max-width: 112px;
        //           white-space: nowrap;
        //           text-overflow: ellipsis;
        //         }
        //         .card-mail .card-mail__tags .tag svg {
        //           width: 24px;
        //         }

        //         @media screen and (max-width: 450px) {
        //           .body-mail {
        //             background-color: transparent;
        //             border-radius: 0;
        //             padding: 0;
        //           }
        //           .content-email {
        //             padding: 0;
        //           }
        //           .card-mail {
        //             width: 145px;
        //             margin: 0 2px 4px;
        //             display: inline-block;
        //             border: 1px solid #0000005b;
        //             background-color: #fff;
        //             padding: 4px;
        //             border-radius: 8px;
        //             height: 100%;
        //           }

        //           .card-mail .card-mail__image {
        //             width: 100%;
        //             border-radius: 4px;
        //             height: 140px;
        //             overflow: hidden;
        //           }
        //           .card-mail .card-mail__image img {
        //             width: 100%;
        //             border-radius: 4px;
        //             object-fit: cover;
        //             height: 100%;
        //           }
        //           .card-mail .card-mail__header {
        //             display: flex;
        //             margin: 8px 0 4px;
        //             align-items: flex-start;
        //             justify-content: space-between;
        //           }
        //           .card-mail .card-mail__header .card-mail__title {
        //             width: 80%;
        //           }
        //           .card-mail .card-mail__header .card-mail__title div {
        //             margin-right: 4px;
        //             font-size: 14px;
        //             line-height: 1.2;
        //             height: 33.6px;
        //             font-weight: 600;
        //             overflow: hidden;
        //           }
        //           .card-mail .card-mail__header .card-mail__logo {
        //             width: 20%;
        //             min-height: 30px;
        //             padding: 4px 0;
        //             border-radius: 8px;
        //             object-fit: cover;
        //             display: flex;
        //             background-color: #fff;
        //             border: 1px solid #0000005b;
        //           }
        //           .card-mail .card-mail__header .card-mail__logo img {
        //             width: 90%;
        //             height: fit-content;
        //             margin: auto;
        //           }

        //           .card-mail .card-mail__footer .price {
        //             color: #592880;
        //             font-size: 18px;
        //             font-weight: 600;
        //           }
        //           .card-mail .card-mail__footer .price span {
        //             font-size: 14px;
        //           }
        //           .card-mail .card-mail__footer .price small {
        //             font-size: 10px;
        //           }
        //           .card-mail .card-mail__footer .favorite {
        //             display: flex;
        //             margin-left: auto;
        //             align-items: center;
        //           }
        //           .card-mail .card-mail__footer .favorite span {
        //             margin-right: 2px;
        //             font-size: 12px;
        //           }
        //           .card-mail .card-mail__footer .favorite img {
        //             width: 14px;
        //           }

        //           .card-mail .card-mail__tags {
        //             color: #fff;
        //             font-size: 14px;
        //             display: flex;
        //             align-items: center;
        //             justify-content: space-between;
        //           }
        //           .card-mail .card-mail__tags .tag {
        //             padding: 0 4px;
        //             border-radius: 4px;
        //             max-width: 80px;
        //             white-space: nowrap;
        //             text-overflow: ellipsis;
        //           }
        //           .card-mail .card-mail__tags .tag svg {
        //             width: 20px;
        //           }
        //         }
        //       </style>
        //     </head>
        //     <body>
        //       <section class="body-mail">
        //         <div class="content-email">${this.editorEmailBody}</div>
        //         <div style="text-align: center; background: #592880; padding: 24px 16px">
        //           <a href="http://kachiing.com">
        //             <img src="https://demo.kachiing.com/assets/images/logo-white.png" style="width: 225px; margin: auto" />
        //           </a>
        //           <div style="margin-top: 16px; color: #fff">This email and any attachments may contain confidential information intended solely for the recipient. If you are not the intended recipient, please notify us immediately and delete this message.</div>
        //         </div>
        //       </section>
        //     </body>
        //   </html>`,
        //   })
        //   .subscribe((resp: ApiResponse) => {
        //     this.toastr.success(resp.message);
        //   });
        // this.emailFullBody.nativeElement.innerHTML

        if (
          this.userEmailList.length > 0 &&
          this.emailSubject &&
          this.editorEmailBody
        ) {
          for (let i of this.userEmailList) {
            this.auth
              .sendMail({
                emailId: i.email,
                subject: this.emailSubject,
                body: ` <html>
                <head>
                  <style>
                    .body-mail {
                      font-size: 16px;
                      width: 100%;
                      max-width: 1300px;
                      margin: 15px auto;
                      font-family: Geneva, "Segoe UI", Tahoma, Verdana, sans-serif;
                      background-color: #f9f9f9;
                      line-height: 1.6;
                      width: 100%;
                      border-radius: 16px;
                      overflow: hidden;
                    }
                    .content-email {
                      padding: 4px 16px;
                    }
    
                    .card-mail {
                      width: 215px;
                      display: inline-block;
                      margin: 0 8px 16px;
                      border: 1px solid #0000005b;
                      background-color: #fff;
                      padding: 8px;
                      border-radius: 8px;
                      height: 100%;
                    }
                    .card-mail .card-mail__image {
                      width: 100%;
                      border-radius: 8px;
                      height: 250px;
                      overflow: hidden;
                    }
                    .card-mail .card-mail__image img {
                      width: 100%;
                      border-radius: 8px;
                      object-fit: cover;
                      height: 100%;
                    }
    
                    .card-mail .card-mail__header {
                      display: flex;
                      margin: 16px 0 8px;
                      align-items: flex-start;
                      justify-content: space-between;
                    }
                    .card-mail .card-mail__header .card-mail__title {
                      width: 80%;
                    }
                    .card-mail .card-mail__header .card-mail__title div {
                      margin-right: 8px;
                      font-size: 18px;
                      line-height: 1.1;
                      height: 39.6px;
                      font-weight: 600;
                      overflow: hidden;
                    }
                    .card-mail .card-mail__header .card-mail__logo {
                      width: 20%;
                      min-height: 50px;
                      padding: 8px 0;
                      border-radius: 8px;
                      object-fit: cover;
                      display: flex;
                      background-color: #fff;
                      border: 1px solid #0000005b;
                    }
                    .card-mail .card-mail__header .card-mail__logo img {
                      width: 85%;
                      height: fit-content;
                      margin: auto;
                    }
    
                    .card-mail .card-mail__footer .price {
                      color: #592880;
                      font-size: 24px;
                      font-weight: 600;
                    }
                    .card-mail .card-mail__footer .price span {
                      font-size: 16px;
                    }
                    .card-mail .card-mail__footer .price small {
                      font-size: 12px;
                    }
                    .card-mail .card-mail__footer .favorite {
                      display: flex;
                      margin-left: auto;
                      align-items: center;
                    }
                    .card-mail .card-mail__footer .favorite span {
                      margin-right: 4px;
                      font-size: 16px;
                    }
                    .card-mail .card-mail__footer .favorite img {
                      width: 16px;
                    }
    
                    .card-mail .card-mail__tags {
                      color: #fff;
                      font-size: 14px;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    }
                    .card-mail .card-mail__tags .tag {
                      padding: 0 4px;
                      border-radius: 4px;
                      max-width: 112px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .card-mail .card-mail__tags .tag svg {
                      width: 24px;
                    }
    
                    @media screen and (max-width: 450px) {
                      .body-mail {
                        background-color: transparent;
                        border-radius: 0;
                        padding: 0;
                      }
                      .content-email {
                        padding: 0;
                      }
                      .card-mail {
                        width: 145px;
                        margin: 0 2px 4px;
                        display: inline-block;
                        border: 1px solid #0000005b;
                        background-color: #fff;
                        padding: 4px;
                        border-radius: 8px;
                        height: 100%;
                      }
    
                      .card-mail .card-mail__image {
                        width: 100%;
                        border-radius: 4px;
                        height: 140px;
                        overflow: hidden;
                      }
                      .card-mail .card-mail__image img {
                        width: 100%;
                        border-radius: 4px;
                        object-fit: cover;
                        height: 100%;
                      }
                      .card-mail .card-mail__header {
                        display: flex;
                        margin: 8px 0 4px;
                        align-items: flex-start;
                        justify-content: space-between;
                      }
                      .card-mail .card-mail__header .card-mail__title {
                        width: 80%;
                      }
                      .card-mail .card-mail__header .card-mail__title div {
                        margin-right: 4px;
                        font-size: 14px;
                        line-height: 1.2;
                        height: 33.6px;
                        font-weight: 600;
                        overflow: hidden;
                      }
                      .card-mail .card-mail__header .card-mail__logo {
                        width: 20%;
                        min-height: 30px;
                        padding: 4px 0;
                        border-radius: 8px;
                        object-fit: cover;
                        display: flex;
                        background-color: #fff;
                        border: 1px solid #0000005b;
                      }
                      .card-mail .card-mail__header .card-mail__logo img {
                        width: 90%;
                        height: fit-content;
                        margin: auto;
                      }
    
                      .card-mail .card-mail__footer .price {
                        color: #592880;
                        font-size: 18px;
                        font-weight: 600;
                      }
                      .card-mail .card-mail__footer .price span {
                        font-size: 14px;
                      }
                      .card-mail .card-mail__footer .price small {
                        font-size: 10px;
                      }
                      .card-mail .card-mail__footer .favorite {
                        display: flex;
                        margin-left: auto;
                        align-items: center;
                      }
                      .card-mail .card-mail__footer .favorite span {
                        margin-right: 2px;
                        font-size: 12px;
                      }
                      .card-mail .card-mail__footer .favorite img {
                        width: 14px;
                      }
    
                      .card-mail .card-mail__tags {
                        color: #fff;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      }
                      .card-mail .card-mail__tags .tag {
                        padding: 0 4px;
                        border-radius: 4px;
                        max-width: 80px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      }
                      .card-mail .card-mail__tags .tag svg {
                        width: 20px;
                      }
                    }
                  </style>
                </head>
                <body>
                  <section class="body-mail">
                    <div class="content-email">  ${this.emailFullBody.nativeElement.innerHTML}</div>
                  
                  </section>
                </body>
              </html>`,
              })
              .subscribe((resp: ApiResponse) => {
                this.toastr.success(resp.message);
              });
          }
        } else {
          this.toastr.error('Invalid EmailId/email/subject');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  public onRegionClick(name) {
    this.selectedMemberRegion = name.name;
    this.selectedMemberRegionId = name.subRegionId;
    this.form.get('subRegionId').setValue(name.subRegionId);
  }

  public getRegionEmailTemplate(selectedRegion) {
    this.selectedMemberRegion = selectedRegion.name;
    let id = selectedRegion.subRegionId;
    this.getEmailList(selectedRegion.subRegionId);


    if (selectedRegion.subRegionId && selectedRegion.name != 'all') {
      this.allSelectedTemplateList = this.allTemplateList.filter(
        (i: any) => (i.subRegionId == id || i.subRegionId == this.commonService.subRegionAllRegionId)
      );
    } else if (selectedRegion.name == 'all') {
      this.allSelectedTemplateList = this.allTemplateList;
    } else {
      this.allSelectedTemplateList = [];
    }
  }

  public formTemplateForSending(selectedTemplate) {
    this.emailSubject = this.allSelectedTemplateList[selectedTemplate]?.subject;
    let template = this.allSelectedTemplateList[selectedTemplate]?.body || '';
    for (let i of EmailBodyTags) {
      if (
        template.includes(i.tag) &&
        i.tag == '<product-section></product-section>'
      ) {
        this.enableAddProductSection = true;
      }

      if (template.includes('<email-logo></email-logo>')) {
        this.templateSection.logo = true;
      }

      if (template.includes('<email-banner></email-banner>')) {
        this.templateSection.banner = true;
      }
    }

    this.emailBody = this.sanitizer.bypassSecurityTrustHtml(template);
    this.footerSection = this.sanitizer.bypassSecurityTrustHtml(
      this.allSelectedTemplateList[selectedTemplate]?.footer || ''
    );
    this.contentEditable = true;
  }

  public getEmailList(subRegionId) {
    this.userEmailList = [];
    this.auth
      .getEmailListBaseOnRegion({
        subRegionId: subRegionId,
      })
      .subscribe((resp: ApiResponse) => {
        this.userEmailList = resp.body;
      });
  }

  public removeEmail(index: number): void {
    if (index >= 0 && index < this.userEmailList.length) {
      this.userEmailList.splice(index, 1);
    }
  }
}
